import { NgForOf, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ComposedLoaderSettings } from '@modules/loaders/interfaces/composed-loader-settings.interface';
import { LoaderService } from '@modules/loaders/services/loader.service';

@Component({
  selector: 'app-music-bars-loader',
  templateUrl: './music-bars-loader.component.html',
  styleUrls: ['../base-loader.component.css'],
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
  ],
})
export class MusicBarsLoaderComponent {
  loader: ComposedLoaderSettings;

  constructor(
    loaderService: LoaderService,
  ) {
    this.loader = loaderService.composedLoaderSettings.getValue();
    loaderService.composedLoaderSettings.subscribe(result => {
      this.loader = result;
    });
  }
}
